// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const EmissionsPartSearch = t.struct({
    partNumber: t.maybe(t.String),
    qualifyForEmissions: t.maybe(t.String)
}, {
    name: 'EmissionsPartSearch',
    strict: true
});

export const getDefaultState = () => new EmissionsPartSearch({});

export default EmissionsPartSearch;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/emissions-part-search.js